export class CredentialsProfileAwsCredentialProfile {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "roleArn",
            "baseName": "roleArn",
            "type": "string",
            "format": ""
        },
        {
            "name": "awsAccountId",
            "baseName": "awsAccountId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CredentialsProfileAwsCredentialProfile.attributeTypeMap;
    }
    constructor() {
    }
}
